import { useMemo } from "react";

/**
 * Custom hook to calculate min/max statistics for price and area from ad data
 * @param {Array} ads - Array of ad objects
 * @returns {Object} Statistics object with minPrice, maxPrice, minArea, maxArea, adsWithMoms, adsWithoutMoms
 */
const useAdStatistics = (ads) => {
  const statistics = useMemo(() => {
    if (!ads || ads.length === 0) {
      return {
        minPrice: null,
        maxPrice: null,
        minArea: null,
        maxArea: null,
        adsWithMoms: 0,
        adsWithoutMoms: 0,
      };
    }

    // Extract all areas (filter out null/undefined)
    const areas = ads
      .map((ad) => ad.area)
      .filter((area) => area != null && area > 0);

    // Extract all prices from all rent types (filter out null/undefined)
    const prices = ads.flatMap((ad) =>
      [
        ad.hourly_rent,
        ad.daily_rent,
        ad.monthly_rent,
        ad.workspace_rent,
      ].filter((price) => price != null && price > 0)
    );

    // Count ads with and without moms
    const adsWithMoms = ads.filter((ad) => ad.vat_tax_required === true).length;
    const adsWithoutMoms = ads.filter(
      (ad) => ad.vat_tax_required === false
    ).length;

    return {
      minPrice: prices.length > 0 ? Math.min(...prices) : null,
      maxPrice: prices.length > 0 ? Math.max(...prices) : null,
      minArea: areas.length > 0 ? Math.min(...areas) : null,
      maxArea: areas.length > 0 ? Math.max(...areas) : null,
      adsWithMoms,
      adsWithoutMoms,
    };
  }, [ads]);

  return statistics;
};

export default useAdStatistics;
